<template>
  <v-card flat>
    <v-select
      :value="tank.id"
      label="タンク"
      :items="tankSelection"
      :readonly="tankSelection.length === 1"
      @input="$emit('change-tank', $event)"
    />

    <TankChart
      :customer="customer"
      :tank="tank"
      :records="records"
      expand
    />
  </v-card>
</template>

<script>
import TankChart from '@/components/charts/TankChart.vue'

export default {
  components: {
    TankChart
  },
  props: {
    customer: {
      type: Object,
      default: () => null
    },
    tank: {
      type: Object,
      default: () => {}
    },
    tankSelection: {
      type: Array,
      default: () => []
    },
    records: {
      type: Array,
      default: () => []
    }
  }
}
</script>
